export default __webpack_public_path__ + "static/media/gallery_06.7f8b5561.jpg";